import React from 'react';
import {oneOf} from 'prop-types';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {Grid, Button} from 'semantic-ui-react';

const MultipleWinnersHeader = props => (
  <Grid className='multiple-winners-header'>
    <Grid.Row>
      <Grid.Column width={2} textAlign='left' verticalAlign='top'>
        <Link to={`/prizes/${props.prizeType}`}>
          <FormattedMessage id='entriesList.link.goBack' />
        </Link>
      </Grid.Column>
      <Grid.Column width={4} textAlign='left' verticalAlign='top' className='prize-title'>
        <FormattedMessage id='multipleWinners.title' />
      </Grid.Column>
      <Grid.Column width={10}>{/* filler */}</Grid.Column>
    </Grid.Row>
  </Grid>
);

MultipleWinnersHeader.propTypes = {
  prizeType: oneOf(['editorial', 'sponsored']).isRequired
};

export default MultipleWinnersHeader;



// WEBPACK FOOTER //
// ./public/pages/MultipleWinners/MultipleWinnersHeader.jsx